import { configureStore } from '@reduxjs/toolkit'
import counterReducer from './storeSlice'


export const store = configureStore({
    reducer: {
        counter: counterReducer,
    },
})

